import {Component, inject, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from "@angular/material/dialog";
import {Match} from "../../model/match";
import {MatButton} from "@angular/material/button";
import {TournamentPlayer} from "../../model/tournamentPlayer";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-counter-selection',
  imports: [
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatDialogActions,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    FormsModule,

  ],
  templateUrl: './counter-selection.component.html',
  standalone: true,
  styleUrl: './counter-selection.component.scss'
})
export class CounterSelectionComponent {

  // counter: TournamentPlayer;
  counter: number;

  readonly dialogRef = inject(MatDialogRef<CounterSelectionComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    match: Match,
    availableCounters: TournamentPlayer[]
  }) {}

  onAnnulerenClick() {
    this.dialogRef.close();
  }

}
